import { render, staticRenderFns } from "./MenuOverview.vue?vue&type=template&id=3ca46ef8"
import script from "./MenuOverview.vue?vue&type=script&lang=js"
export * from "./MenuOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports